import { render } from "./ElectionVoteElecomEPView.vue?vue&type=template&id=f595fa40"
import script from "./ElectionVoteElecomEPView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteElecomEPView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__